const links = {
  flat: {
    fontFamily: 'heading',
    fontSize: 4,
    fontWeight: 'normal',
    color: 'black',
    textDecoration: 'none',
    p: 2,
  },
  special: {
    fontFamily: 'heading',
    fontSize: 4,
    fontWeight: 'bold',
    color: 'primary',
    lineHeight: 'heading',
    textDecoration: 'underline',
    textDecorationColor: 'lightBlue',
  },
  navigation: {
    fontFamily: 'heading',
    color: 'white',
    textDecoration: 'none',
  },
  mobileNavigation: {
    fontFamily: 'body',
    color: 'white',
    textDecoration: 'none',
    fontSize: 3,
    appearance: 'none',
    py: 3,
  },
  allCaps: {
    fontFamily: 'body',
    color: 'primary',
    fontSize: 0,
    fontWeight: 'semiBold',
    textTransform: 'uppercase',
    textDecoration: 'none',
  },
  none: {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    color: 'inherit',
    textDecoration: 'none',
    p: 'inherit',
  },
}

export default links
